export const tableHeaderConfig: {
    id: string | number;
    name: string;
    isHidable: boolean;
    isSortableByBestMatch?: boolean;
    isSortableByDate?: boolean;
    sort?: { isSortableByBestMatch?: boolean; sortBy?: "date" | "a-z" };
    isHidden?: boolean;
    sx: React.CSSProperties;
}[] = [
    {
        id: "name",
        name: "User",
        isHidable: false,
        sort: { isSortableByBestMatch: false, sortBy: "a-z" },
        sx: { width: 300 },
    },
    {
        id: "roles",
        name: "Role",
        isHidable: false,
        sx: { width: 200 },
    },
    {
        id: "last_active_datetime",
        name: "Last Active",
        isHidable: false,
        sort: { isSortableByBestMatch: false, sortBy: "date" },
        sx: { width: 150 },
    },
];
